import React, { useState } from 'react';
import { IconButton } from '@fluentui/react';
import { t } from 'i18next';
import { DetailsListView } from '../../Common/DetailsList/DetailListView';
import { GRID_MODE } from '../../../common/list-utils';
import StatusFilms from './StatusFilms';
import FileFolder from '../../FileDropzone/FileFolder';
import FileDropzone from '../../FileDropzone/FileDropzone';
import { useSettlementFilters } from './hooks/useSettlementFilters';
import { useSettlementUpload } from './hooks/useSettlementUpload';
import { useSettlementDownload } from './hooks/useSettlementDownload';
import { getStatusCircleClass } from './utils/settlementUtils';
import { CargaProps } from './interfaces/carga-props';
import './Carga.css';
import { useSettlementDelete } from './hooks/useSettlementDelete';

export default function ConsultanciesPeruView(props: CargaProps) {
  const [refresh, setRefresh] = useState(false);
  const liqins_agrcorliq_id = 3;

  const filters = useSettlementFilters()
  const { upload } = useSettlementUpload(props, liqins_agrcorliq_id, setRefresh)
  const { download } = useSettlementDownload(props)
  const { remove } = useSettlementDelete(props)

  /** Subir archivo */
  const handleDrop = async (folder: FileFolder, item: any) => {
    const file = folder.getFiles()[0];
    if (!file) return props.courier.messageError(t('No se ha seleccionado ningún archivo.'));
    upload(file, item);
  };

  /** Eliminar archivo */
  const handleDelete = async (item: any) => {
    await remove(item.liqins_id, () => {
      setRefresh(true);
    });
  };

  const listLevelsColumns = [
    {
      key: 'liqins_activo',
      fieldName: 'liqins_activo',
      name: t('Estado'),
      minWidth: 50,
      maxWidth: 50,
      isResizable: false,
      _onRender(item) {
        return (
          <div style={{ width: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className={`status-films__circle ${getStatusCircleClass(item.liqins_activo)}`} />
          </div>
        );
      },
    },
    {
      key: 'inst_nombre',
      fieldName: 'inst_nombre',
      name: t('Insumo'),
    },
/*     {
      key: 'forzar_llamado',
      name: t('Forzar llamado'),
      fieldName: 'forzar',
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
      _onRender(item) {
        return (
          <div style={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '-7px' }}>
            <IconButton iconProps={{ iconName: 'DatabaseSync' }} title="Forzar llamado" ariaLabel="Forzar llamado" onClick={() => handleForceCall(item)} />
          </div>
        );
      },
    }, */
    {
      key: 'liqins_name_file',
      fieldName: 'liqins_name_file',
      name: t('Seleccionar insumo'),
      minWidth: 300,
      maxWidth: 300,
      width: 300,
      isResizable: true,
      _onRender(item) {
        return (
          <div style={{ marginTop: '-7px' }}>
            {!item.liqins_name_file ? (
              <FileDropzone
                openOnClick
                multiple={false}
                className={`fit-width border-rounded`}
                // onDropStart={() => props.changeBlockUI(true)}
                // onDropEnd={() => props.changeBlockUI(false)}
                onUploadTooLarge={() => props.courier.messageWarning('El archivo excede el tamaño permitido')}
                onDrop={(folder) => handleDrop(folder, item)}
              >
                <label className={`file-upload__label`}>
                  {t("Arrastra o selecciona un archivo")}
                </label>
              </FileDropzone>
            ) : (
              <label className={`file-upload__label ${item.liqins_name_file ? 'file-upload__label--disabled' : ''}`}>
                {item.liqins_name_file}
              </label>
            )}
          </div>
        );
      },
    },
    {
      key: 'liqins_fecha_carga',
      fieldName: 'liqins_fecha_carga',
      name: t('Inicio de carga'),
    },
    {
      key: 'liqins_fecha_fin_carga',
      fieldName: 'liqins_fecha_fin_carga',
      name: t('Fin de carga'),
    },
    {
      key: 'duracion',
      fieldName: 'duracion',
      name: t('Duración'),
    },
    {
      key: 'descargar',
      fieldName: 'descargar',
      name: t('Descargar insumo'),
      isResizable: false,
      minWidth: 100,
      maxWidth: 100,
      _onRender(item) {
        return (
          <div
            style={{
              width: 100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '-7px'
            }}>
            <IconButton
              iconProps={{ iconName: 'Download' }}
              title="Descargar"
              ariaLabel="Descargar"
              styles={{
                root: { color: item.liqins_path ? '#187cff' : '#aaa' } }}
              disabled={!item.liqins_path}
              onClick={() => download(item)} />
          </div>
        );
      },
      onColumnClick: () => {}, // Evitar ordenamiento por esta columna
    },
    {
      key: "eliminar",
      fieldName: "eliminar",
      name: t("Eliminar insumo"),
      isResizable: false,
      minWidth: 100,
      maxWidth: 100,
      _onRender(item) {
        return (
          <div
            style={{
              width: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "-7px",
            }}
          >
            <IconButton
              iconProps={{ iconName: "Delete" }}
              title="Eliminar"
              ariaLabel="Eliminar"
              styles={{ root: { color: item.liqins_path ? "#e81123" : "#aaa" } }}
              disabled={!item.liqins_path}
              onClick={() => handleDelete(item)}
            />
          </div>
        );
      },
      onColumnClick: () => {}, // Evitar ordenamiento por esta columna
    },
  ];

  const baseUrl = React.useMemo(() => {
    // return props.system.getActivitySystem().getBaseUrlForDatagrid();
    setRefresh(false);
    return props.system.getSettlementSystem().getBaseUrlForDatagridLiquidacionInsumo(liqins_agrcorliq_id);
  }, [props]);

  return (
    <DetailsListView
      renderBeforeHeader={<StatusFilms />}
      refresh={refresh}
      keyList={props.path}
      onClickCardMode={() => {}}
      onClickGridMode={() => {}}
      mode={GRID_MODE}
      title={t('Asesorias perú')}
      cols={listLevelsColumns}
      isGridList={true}
      listFilters={[]}
      quickFilters={filters}
      baseUrl={baseUrl}
      changeBlockUI={props.changeBlockUI}
      courier={props.courier}
    />
  );
}
